import * as React from "react";
import {Stack} from "@fluentui/react";
import {getTheme} from "@fluentui/react";
import {FontSizes, FontWeights, NeutralColors} from "@fluentui/react";
import {MoneyFormat} from "../Utilities/MoneyFormat";

function Card({color, title, value}) {

    const theme = getTheme();
    const style = {
        root: {
            alignItems: 'middle',
            flexDirection: 'column',
            display: 'flex',
            height: 100,
            justifyContent: 'middle',
            overflow: 'hidden',
            width: 300,
            boxShadow: theme.effects.elevation8,
            borderTopWidth: 8,
            borderTopColor: color,
            borderTopStyle: 'solid',
            margin: 12
        },
    };
    if (value !== undefined && value !== null) {
        return (
            <Stack.Item styles={style}>
                <h5 style={{fontSize: FontSizes.size16, fontWeight: FontWeights.light, color: NeutralColors.gray100, height: 20, margin: 10}}>{title}</h5>
                <p style={{fontSize: FontSizes.size32, fontWeight: FontWeights.light, height: 40, margin: 10}}>{MoneyFormat(value)}</p>
            </Stack.Item>
        )
    }
    return null;

}
export default Card;